<template>
  <div>
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    <div class="container" v-else>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>campaign</md-icon>
          </div>
          <h4 class="title">{{ isEdit ? $t("advertising.edit.title") : $t("advertising.create.title") }}</h4>
        </md-card-header>
        <!-- Advertising -->
        <md-card-content>
          <div class="md-layout">
            <!-- Select game -->
            <md-field :class="{
                'md-error': $v.advertisingModel.gameId.$error && $v.advertisingModel.gameId.$invalid,
                'md-valid': !$v.advertisingModel.gameId.$error && !$v.advertisingModel.gameId.$invalid}">
              <label>{{ $t("advertising.create.game") }}</label>
              <md-select v-model.trim="$v.advertisingModel.gameId.$model" name="game" id="game" :disabled="isEdit">
                <md-option v-for="game in nextGames" :value="game.id" :key="game.id">{{game.local.name}} vs {{game.visitor.name}} | {{getDate(game.scheduledMatchDate)}} - {{game.season.name}} Fecha : {{game.matchday}}</md-option>
              </md-select>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.advertisingModel.gameId.$error && $v.advertisingModel.gameId.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.advertisingModel.gameId.$error && !$v.advertisingModel.gameId.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- Select teams -->
            <md-field :class="{'md-valid': !$v.advertisingModel.teamId.$error && !$v.advertisingModel.teamId.$invalid}">
              <label>{{ $t("advertising.create.team") }}</label>
              <md-select v-model.trim="$v.advertisingModel.teamId.$model" name="team" id="team" :disabled="isEdit">
                <md-option :value="0">{{ $t("advertising.create.teamBoth") }}</md-option>
                <md-option v-for="team in listTeams" :value="team.id" :key="team.id">{{team.name}}</md-option>
              </md-select>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.advertisingModel.teamId.$error && !$v.advertisingModel.teamId.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>
          <!-- Items -->
          <div class="md-layout mt-20">
            <h4 class="title">{{ $t("advertising.create.listAdvertising") }}</h4>
          </div>
          <div>

            <md-table>
              <md-table-row>
                <md-table-head>{{ $t("advertising.create.order") }}</md-table-head>
                <md-table-head>{{ $t("advertising.create.advertising") }}</md-table-head>
                <md-table-head>{{ $t("advertising.create.actions") }}</md-table-head>
              </md-table-row>

              <md-table-row v-for="(item, itemIndex) in $v.advertisingModel.items.$each.$iter" :key="itemIndex">
                <md-table-cell>{{item.indexOrder.$model}}</md-table-cell>
                <md-table-cell>
                  <a :href="item.url.$model" target="_blank">{{item.url.$model}}</a>
                </md-table-cell>
                <md-table-cell>
                  <md-button class="md-simple" :disabled="itemIndex == 0" @click="changePosition('up', itemIndex)">
                    <md-icon v-if="itemIndex > 0">north</md-icon>
                  </md-button>
                  <md-button class="md-simple" :disabled="(Number(itemIndex) + 1) == advertisingModel.items.length" @click="changePosition('down', itemIndex)">
                    <md-icon v-if="(Number(itemIndex) + 1) < advertisingModel.items.length">arrow_downward</md-icon>
                  </md-button>  
                  <md-button class="md-info" @click="editAdvertising(itemIndex)">
                    <md-icon>edit</md-icon>
                  </md-button>
                  <md-button class="md-danger" @click="removeAdvertising(itemIndex)">
                    <md-icon>close</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <!-- New  -->
              <md-table-row>
                <md-table-cell></md-table-cell>
                <md-table-cell>
                  <md-button class="md-success" @click="modalAdvertising = true">
                    <md-icon>add</md-icon>
                    {{ $t("advertising.create.add") }}
                  </md-button>  
                </md-table-cell>
                <md-table-cell></md-table-cell>
              </md-table-row>
            </md-table>
          </div> 

        </md-card-content>
        <md-card-actions>
          <md-button @click="createEditAdvertising" :disabled="submittedAdvertising" class="md-info" :class="{ disabled: submittedAdvertising }">
            {{ isEdit ? $t("advertising.edit.edit") : $t("advertising.create.create") }}
          </md-button>

          <md-button @click="deleteAdvertising" :disabled="deletedAdvertising" class="md-danger md-simple button-delete" :class="{ disabled: deletedAdvertising }">
            {{ $t("advertising.edit.delete") }}
          </md-button>
        </md-card-actions>
      </md-card>
    </div>

    <!-- Modal New Advertising -->
    <modal v-if="modalAdvertising" @close="modalAdvertising = false">
      <template slot="header">
        <h4 class="modal-title">{{$t('advertising.modal.title')}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalAdvertising = false">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-radio v-model="typeLoadAdvertising" value="video">Link Video</md-radio>
        <md-radio v-model="typeLoadAdvertising" value="upload">Desde mi ordenador</md-radio>

        <div>
          <div>  
            <md-field
              v-if="typeLoadAdvertising == 'video'"
              :class="{ 'md-valid': advertisingModelModal.url != '' }">
              <label>{{ $t("advertising.create.urlVideo") }}</label>
              <md-input type="text" v-model.trim="advertisingModelModal.url"></md-input>
              <slide-y-down-transition>
                <md-icon class="success" v-show="advertisingModelModal.url != ''">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <p class="text-info">{{ $t("advertising.create.legendUrl") }}</p>
          </div>
          <div v-if="typeLoadAdvertising == 'upload'">
            <input type="file" accept="video/mp4,video/x-m4v,video/*" ref="uploadVideo" @change="uploadNewVideo" style="display:none"/>
            <md-button class="md-block" @click="$refs.uploadVideo.click()" :disabled="loadingUploadAdvertising">
              <md-icon>cloud_upload</md-icon>
              {{ $t("advertising.create.uploadVideo") }}
            </md-button>
            <a :href="advertisingModelModal.url">{{advertisingModelModal.url}}</a>
          </div>
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-simple md-success" :disabled="loadingUploadAdvertising || advertisingModelModal.url == ''" @click="addAdvertising">
          {{ $t("advertising.modal.confirm") }}
        </md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import { required } from "vuelidate/lib/validators";
import { mapState } from 'vuex'; 
import storage from "@/plugins/azure-storage";
import { Modal } from '@/components'

export default {
  components: {
    SlideYDownTransition,
    Modal
  },
  data() {
    return {
      isEdit: false,
      loading: true,
      submittedAdvertising: false,
      loadingUploadAdvertising: false,
      deletedAdvertising: false,
      modalAdvertising: false,
      typeLoadAdvertising: "video",
      listTeams: [],
      advertisingModel: {
        gameId: null,
        teamId: 0,
        items: []
      },
      advertisingModelModal: {
        index: null,
        url: '',
        indexOrder: null
      }
    }
  },
  computed: {
    ...mapState({
      nextGames: state => state.GameModule.nextGames
    })
  },
  async mounted() {
    await this.$store.dispatch("gameGetNext")
    this.isEdit = this.$route.params.id != undefined
    if (this.isEdit) {
      this.advertisingModel = await this.$store.dispatch("getAdvertising", {
        id: this.$route.params.id
      }) 
      this.$v.advertisingModel.items.$model.sort(function(a, b) { 
          return a.indexOrder - b.indexOrder;
      })
      this.loadTeams()
    }
    this.loading = false
  },
  methods: {
    async createEditAdvertising() {
      this.$v.advertisingModel.$touch();
      if (!this.$v.advertisingModel.$invalid) {
        this.submittedAdvertising = true;
        if (this.isEdit) {
          await this.$store.dispatch('updateAdvertising', this.advertisingModel)
        } else {
          await this.$store.dispatch('createAdvertising', this.advertisingModel)
        }
        this.$notify({
          message: this.isEdit ? this.$t('notifications.advertising.update') : this.$t(`notifications.advertising.create`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.submittedAdvertising = false;
        this.$router.push("/list/advertising");
      }
    },
    getDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    },
    addAdvertising() {
      if (this.advertisingModelModal.index != null) {
        this.$v.advertisingModel.items.$each.$iter[this.advertisingModelModal.index].$model.url = this.advertisingModelModal.url 
        this.$v.advertisingModel.items.$each.$iter[this.advertisingModelModal.index].$model.indexOrder = this.advertisingModelModal.indexOrder 
      } else {
        this.advertisingModelModal.indexOrder = this.advertisingModel.items.length + 1;
        this.$v.advertisingModel.items.$model.push(this.advertisingModelModal);
      }
      this.advertisingModelModal = {
        index: null,
        url: '',
        indexOrder: null
      }
      this.modalAdvertising = false;
    },
    editAdvertising(index) {
      this.advertisingModelModal = {
        index,
        url: this.advertisingModel.items[index].url,
        indexOrder: this.advertisingModel.items[index].indexOrder,
      };
      this.modalAdvertising = true; 
    },
    async uploadNewVideo(e) {
      this.loadingUploadAdvertising = true;
      const file = e.target.files[0];
      const fileName = await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_ADVERTISING
      });
      this.advertisingModelModal.url = `${process.env.VUE_APP_CDN_URL_ADVERTISING}${fileName}`;
      this.loadingUploadAdvertising = false;
    },
    removeAdvertising(index) {
      this.advertisingModel.items.splice(index, 1);
    },
    loadTeams() {
      const gameSelect = this.nextGames.find(game => game.id == this.advertisingModel.gameId)
      this.listTeams = [
        gameSelect.local,
        gameSelect.visitor
      ]
    },
    async deleteAdvertising() {
      this.deletedAdvertising = true
      await this.$store.dispatch('deleteAdvertising', {id : this.$route.params.id})
      this.$notify({
        message: this.$t(`notifications.advertising.delete`),
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'success'
      })
      this.deletedAdvertising = false;
      this.$router.push("/list/advertising");
    },
    changePosition(direction, index) {
      const idx = Number(index)
      if (direction == 'up') {
        this.$v.advertisingModel.items.$each.$iter[idx].$model.indexOrder -= 1;
        this.$v.advertisingModel.items.$each.$iter[idx - 1].$model.indexOrder += 1;
      } else if (direction == 'down') {
        this.$v.advertisingModel.items.$each.$iter[idx].$model.indexOrder += 1;
        this.$v.advertisingModel.items.$each.$iter[idx + 1].$model.indexOrder -= 1;
      }

      this.$v.advertisingModel.items.$model.sort(function(a, b) { 
          return a.indexOrder - b.indexOrder;
      })
    }
  },
  watch: {
    'advertisingModel.gameId': function() {
      this.loadTeams()
    }
  },
  validations: {
    advertisingModel: {
      gameId: {
        required
      },
      teamId: {},
      items: {
        $each: {
          indexOrder: {
            required
          },
          url: {
            required
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.mt-20 {
  margin-top: 20px;
}
.button-delete {
  float: right;
}
.flex-cell {
  display: flex;
}
</style>